export default __webpack_public_path__ + "static/media/3.bd20f96c.png";